import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import {useDispatch} from "react-redux";
import * as actions from '../../_redux/projectsActions';
import * as commonColumnFormatters from '../../../_common/column-formatters';
import {useProjectsUIContext} from '../ProjectsUIContext';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../../_common/components/CommonGrid/CommonGrid";

export function ProjectsTable() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [tableRows, setTableRows] = useState([]);

  const columns = useMemo(() => [
    {
      accessor: 'name',
      Header: intl.formatMessage({
        id: 'projects-column-name', defaultMessage: 'Name'
      })
    },
    {
      accessor: 'createdAt',
      Header: intl.formatMessage({
        id: 'projects-column-createdAt', defaultMessage: 'Created at'
      })
    },
    {
      accessor: 'customersCount',
      Header: intl.formatMessage({
        id: 'projects-column-customers', defaultMessage: 'Customers'
      })
    },
    {
      accessor: 'import',
      Header: intl.formatMessage({
        id: 'projects-column-import', defaultMessage: 'Import'
      })
    },
    {
      accessor: 'export',
      Header: intl.formatMessage({
        id: 'projects-column-export', defaultMessage: 'Export'
      })
    },
    {
      accessor: 'edit',
      Header: intl.formatMessage({
        id: 'projects-column-edit', defaultMessage: 'Edit'
      })
    },
    {
      accessor: 'delete',
      Header: intl.formatMessage({
        id: 'projects-column-delete', defaultMessage: 'Delete'
      })
    },
  ], [intl]);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        name: commonColumnFormatters.BoldColumnFormatter(item.name),
        createdAt: commonColumnFormatters.DateColumnFormatter(item.createdAt),
        customersCount: commonColumnFormatters.BoldColumnFormatter(item.customersCount || ''),
        import: commonColumnFormatters.ImportCustomersForProjectColumnFormatter(item._id),
        export: commonColumnFormatters.ExportCustomersForProjectColumnFormatter(item._id, dispatch),
        edit: commonColumnFormatters.EditProjectColumnFormatter(item._id, item.name, item.customers),
        delete: commonColumnFormatters.DeleteProjectColumnFormatter(item._id, dispatch, intl),
      };
    })
  ], [tableRows, intl, dispatch]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'projects',
    UIContext: useProjectsUIContext(),
    getNewEntities: actions.getProjects,
    getNextEntities: actions.getNextProjects,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customScrollContainerID={'projectsScrollContainer'}
      customTableStyles={'projects-table'}
    />
  );
}
